module.exports = __webpack_public_path__ + "static/media/storage_icon.1bcf49f4.svg";